import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 4H3v16h18V4zm-2 14H5V6h14v12z"
}), 'Crop32Sharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Crop32Sharp.js
// module id = 2992
// module chunks = 2